import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ViewData = () => {
  const [data, setData] = useState([]);

  
const [currentPage, setCurrentPage] = useState(1);
const rowsPerPage = 10; // you can change this (5, 10, etc.)

  useEffect(() => {
    fetchData();
  }, []);


  

  const fetchData = async () => {
    try {
      const res =await axios.get(`${API_BASE_URL}/api/viewdata/`);
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentData = data.slice(indexOfFirstRow, indexOfLastRow);

const totalPages = Math.ceil(data.length / rowsPerPage);


  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Registered Candidates</h2>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.headerRow}>
                <th style={styles.th}>Sr No</th>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>Contact Info</th>
                <th style={styles.th}>Education</th>
                <th style={styles.th}>Passing Year</th>
                <th style={styles.th}>Previous Year %</th>
                <th style={styles.th}>Skills</th>
                <th style={styles.th}>Education Type</th>
              <th style={styles.th}>Current Sem</th>
<th style={styles.th}>Experience</th>
                <th style={styles.th}>Location</th>
                <th style={styles.th}>Resume</th>
              </tr>
            </thead>
            <tbody>
              {/* {data.map((item, index) => ( */}
              {currentData.map((item, index) => (
                <tr
                  key={index}
                  style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}
                >
                  <td style={styles.td}>
  {(currentPage - 1) * rowsPerPage + index + 1}
</td>
                  <td style={styles.td}>
                    <strong>
                      {item.first_name} {item.last_name}
                    </strong>
                  </td>
                  <td style={styles.td}>
                    <div style={styles.smallText}>{item.email}</div>
                    <div style={styles.subText}>{item.phone}</div>
                  </td>
                  <td style={styles.td}>
                    <div style={styles.smallText}>{item.college_name}</div>
                    <div style={styles.subText}>{item.course_name}</div>
                  </td>
                  <td style={styles.td}>{item.passing_year}</td>
                  <td style={styles.td}>
                    <span style={styles.badgeBlue}>
                      {item.last_year_percentage}%
                    </span>
                  </td>
                 <td style={styles.td}>
  <div style={styles.skillContainer}>
    {Array.isArray(item.skills) && item.skills.length > 0 ? (
      item.skills.map((skill, i) => (
        <span key={i} style={styles.skillTag}>
          {skill.skill_name}
        </span>
      ))
    ) : (
      <span style={{ color: "#aaa" }}>No skills</span>
    )}
  </div>
</td>

<td style={styles.td}>
  {item.education_type || "N/A"}
</td>

<td style={styles.td}>
  {item.current_sem || "N/A"}
</td>

<td style={styles.td}>
  {item.experience_years !== null && item.experience_years !== undefined
    ? `${item.experience_years} yrs`
    : "Fresher / N/A"}
</td>
                  
                  <td style={styles.td}>{item.location}</td>
                  <td style={styles.td}>
                    {item.resume && (
                      <a
                        href={`${API_BASE_URL}/api/download/${item.id}/`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.downloadBtn}
                      >
                        Download
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={styles.pagination}>
  <button
    onClick={() => setCurrentPage(currentPage - 1)}
    disabled={currentPage === 1}
    style={styles.pageBtn}
  >
    ◀
  </button>

  <span style={styles.pageInfo}>
    {currentPage} / {totalPages}
  </span>

  <button
    onClick={() => setCurrentPage(currentPage + 1)}
    disabled={currentPage === totalPages}
    style={styles.pageBtn}
  >
    ▶
  </button>
</div>
        </div>
      </div>
    </div>
  );
};

// Professional CSS-in-JS Styles
const styles = {
  container: {
    padding: "40px 20px",
    backgroundColor: "#f4f7f6",
    minHeight: "100vh",
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    padding: "25px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  title: {
    color: "#2c3e50",
    marginBottom: "30px",
    fontSize: "24px",
    fontWeight: "600",
    borderBottom: "2px solid #eee",
    paddingBottom: "15px",
  },
  tableWrapper: {
    overflowX: "auto", // Responsive scroll for small screens
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
  },
  headerRow: {
    backgroundColor: "#f8f9fa",
  },
  th: {
    textAlign: "left",
    padding: "15px",
    fontSize: "13px",
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: "#7f8c8d",
    borderBottom: "2px solid #edf2f7",
  },
  td: {
    padding: "15px",
    fontSize: "14px",
    color: "#34495e",
    borderBottom: "1px solid #edf2f7",
    verticalAlign: "middle",
  },
  rowEven: { backgroundColor: "#ffffff" },
  rowOdd: { backgroundColor: "#fafbfc" },
  smallText: { fontWeight: "500", color: "#2c3e50" },
  subText: { fontSize: "12px", color: "#95a5a6", marginTop: "4px" },
  badgeBlue: {
    display: "inline-block",
    padding: "2px 8px",
    backgroundColor: "#e1effe",
    color: "#1e429f",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "5px",
  },
  skillContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },
  skillTag: {
    backgroundColor: "#f1f3f5",
    color: "#495057",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "11px",
    border: "1px solid #dee2e6",
  },
  downloadBtn: {
    display: "inline-block",
    backgroundColor: "#10b981",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "13px",
    fontWeight: "500",
    transition: "all 0.2s ease",
    textAlign: "center",
    boxShadow: "0 2px 4px rgba(16, 185, 129, 0.2)",
  },
  pagination: {
  marginTop: "20px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "10px",
},

pageBtn: {
  padding: "8px 14px",
  border: "none",
  borderRadius: "6px",
  backgroundColor: "#3498db",
  color: "#fff",
  cursor: "pointer",
},

pageInfo: {
  fontSize: "14px",
  color: "#2c3e50",
},
};

export default ViewData;